import { Loading } from "@omnijus/common";
import React, { useEffect, useState } from "react";
import { ListarAtividades } from "../../../services/atividade/models/listar-atividades";
import { AtividadeFiltroService } from "../../../services/filtros/filtros-atividades-service";
import { OmnijusSelectField } from "../../../shared/form/fields/omnijus-select-field";

interface OmnijusFiltroAtividadeProps {
    hideLabel?: boolean;
    name?: string;
    textSearchName?: string;
    label?: string;
    isMulti?: boolean;
    idArea?: number;
}

export const OmnijusFiltroAtividade = (props: OmnijusFiltroAtividadeProps) => {
    const [promiseOpcoesAtividade, setPromiseOpcoesAtividade] = useState<Promise<ListarAtividades[] | undefined>>();
    const name = props.name || "IdAtividade"

    useEffect(() => {
        setPromiseOpcoesAtividade(AtividadeFiltroService.listarAtividades(props.idArea));
    }, [props.idArea]);

    return (
        <Loading promise={promiseOpcoesAtividade}>
            {(opcoesArea) => (
                <OmnijusSelectField
                    name={name}
                    label={props.hideLabel ? undefined : props.label || "Atividade"}
                    isMulti={props.isMulti}
                    options={opcoesArea
                        ?.map((o) => ({
                            value: o.idAtividade,
                            label: o.descricaoAtividade || "",
                        }))
                        .sort((a, b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0))}
                />
            )}
        </Loading>
    );
};
